/* =========================================================
   WILDTON — INTERNAL PAGE TRANSITION
   Same-origin link transition only.
   Does NOT replace the first-entry intro.
========================================================= */
(() => {
  'use strict';

  const INCOMING_KEY = 'wt_nav_transition_in_v1';
  const COVER_MS = 430;
  const REVEAL_DELAY_MS = 70;
  const REVEAL_MS = 430;

  const html = document.documentElement;
  const overlay = document.querySelector('[data-wt-nav-transition]');

  if (!overlay) {
    html.classList.remove('wt-nav-prepaint', 'wt-nav-lock');
    return;
  }

  const isDesignMode = Boolean(
    (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode')
  );

  const safeGet = (key) => {
    try { return sessionStorage.getItem(key); }
    catch (_) { return null; }
  };

  const safeSet = (key, value) => {
    try { sessionStorage.setItem(key, value); }
    catch (_) {}
  };

  const safeRemove = (key) => {
    try { sessionStorage.removeItem(key); }
    catch (_) {}
  };

  const resetOverlay = () => {
    overlay.classList.remove('is-visible', 'is-covering', 'is-revealing');
    html.classList.remove('wt-nav-prepaint', 'wt-nav-lock');
  };

  if (isDesignMode) {
    safeRemove(INCOMING_KEY);
    resetOverlay();
    return;
  }

  const incoming = safeGet(INCOMING_KEY) === '1';

  if (incoming) {
    safeRemove(INCOMING_KEY);

    overlay.classList.add('is-visible');
    html.classList.add('wt-nav-lock');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        html.classList.remove('wt-nav-prepaint');

        window.setTimeout(() => {
          overlay.classList.add('is-revealing');

          window.setTimeout(() => {
            resetOverlay();
          }, REVEAL_MS);
        }, REVEAL_DELAY_MS);
      });
    });
  } else {
    html.classList.remove('wt-nav-prepaint', 'wt-nav-lock');
  }

  const isEligibleLink = (anchor, event) => {
    if (!anchor || !anchor.href) return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;

    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return false;

    if (anchor.hasAttribute('download')) return false;
    if (anchor.hasAttribute('data-no-page-transition')) return false;
    if (anchor.closest('[data-no-page-transition]')) return false;

    const target = anchor.getAttribute('target');
    if (target && target !== '_self') return false;

    const rawHref = (anchor.getAttribute('href') || '').trim();

    if (
      !rawHref ||
      rawHref.startsWith('#') ||
      rawHref.startsWith('mailto:') ||
      rawHref.startsWith('tel:') ||
      rawHref.startsWith('sms:') ||
      rawHref.startsWith('javascript:')
    ) return false;

    let url;

    try {
      url = new URL(anchor.href, window.location.href);
    } catch (_) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;

    /*
      Same-page anchors/search state changes do not need a full-screen cover.
    */
    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search
    ) {
      return false;
    }

    /*
      Do not interfere with AJAX cart/payment components.
    */
    if (
      anchor.closest(
        'form,' +
        '.shopify-payment-button,' +
        '[data-shopify="payment-button"],' +
        '[data-cart-drawer],' +
        'cart-drawer,' +
        'quick-add-modal,' +
        'quick-add-component'
      )
    ) {
      return false;
    }

    return true;
  };

  let navigating = false;

  const coverAndNavigate = (href) => {
    if (navigating) return;
    navigating = true;

    html.classList.add('wt-nav-lock');

    overlay.classList.remove('is-revealing');
    overlay.classList.add('is-visible');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        overlay.classList.add('is-covering');

        window.setTimeout(() => {
          safeSet(INCOMING_KEY, '1');
          window.location.href = href;
        }, COVER_MS);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest && event.target.closest('a[href]');

    if (!isEligibleLink(anchor, event)) return;

    event.preventDefault();
    coverAndNavigate(anchor.href);
  }, true);

  /*
    Browser back/forward cache safety.
  */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    navigating = false;
    safeRemove(INCOMING_KEY);
    resetOverlay();
  });
})();
